import React from "react"
import SaleStage from "../components/SaleStage"

class StepSS1 extends React.Component {
    render() {

        const { client, updateClient } = this.props;
        const { reservation={} } = (client && client.stages_of_sale) || {};

        const {
            clearedPaymentOfReservationFee,
            buyersInformationSheet,
            reservationAgreementFile,
            reservationAgreementDate,
            signedFinalComputationFile,
            signedFinalComputationDate,
            signedSiteDevelopmentPlanWithLotAreaMarked,
            signedFloorPlan,
            signedMaterialsSpecifications,
            signedSwornDeclarationFile,
            signedSwornDeclarationDate,
            oneValidGovtIdWithThreeSpecimenSignature,
            signedInterviewSheetByBothSalesAdminAndBuyerSpaFile,
            signedInterviewSheetByBothSalesAdminAndBuyerSpaDate,
            sellerForm,
            commissionBreakdown,
            waterRates,
            isCompleted,
            completionDate,
            others=[]
        } = reservation;

        const step1Fields = [
            { key: 'clearedPaymentOfReservationFee', type: 'date', label: 'Cleared Payment Of Reservation Fee', value: clearedPaymentOfReservationFee},
            { key: 'buyersInformationSheet', type: 'file', label: 'Buyers Information Sheet', value: buyersInformationSheet},
            { key: 'reservationAgreementFile', type: 'file', label: 'Reservation Agreement File', value: reservationAgreementFile},
            { key: 'reservationAgreementDate', type: 'date', label: 'Reservation Agreement Date', value: reservationAgreementDate},
            { key: 'signedFinalComputationFile', type: 'file', label: 'Signed Final Computation File', value: signedFinalComputationFile},
            { key: 'signedFinalComputationDate', type: 'date', label: 'Signed Final Computation Date', value: signedFinalComputationDate},
            { key: 'signedSiteDevelopmentPlanWithLotAreaMarked', type: 'file', label: 'Signed Site Development Plan With Lot Area Marked', value: signedSiteDevelopmentPlanWithLotAreaMarked},
            { key: 'signedFloorPlan', type: 'file', label: 'Signed Floor Plan', value: signedFloorPlan},
            { key: 'signedMaterialsSpecifications', type: 'file', label: 'Signed Materials Specifications', value: signedMaterialsSpecifications},
            { key: 'signedSwornDeclarationFile', type: 'file', label: 'Signed Sworn Declaration File', value: signedSwornDeclarationFile},
            { key: 'signedSwornDeclarationDate', type: 'date', label: 'Signed Sworn Declaration Date', value: signedSwornDeclarationDate},
            { key: 'oneValidGovtIdWithThreeSpecimenSignature', type: 'file', label: 'One Valid Goverment Id With Three Specimen Signature', value: oneValidGovtIdWithThreeSpecimenSignature},
            { key: 'signedInterviewSheetByBothSalesAdminAndBuyerSpaFile', type: 'file', label: 'Signed Interview Sheet By Both Sales Admin And Buyer SPA File', value: signedInterviewSheetByBothSalesAdminAndBuyerSpaFile},
            { key: 'signedInterviewSheetByBothSalesAdminAndBuyerSpaDate', type: 'date', label: 'Signed Interview Sheet By Both Sales Admin And Buyer SPA Date', value: signedInterviewSheetByBothSalesAdminAndBuyerSpaDate},
            { key: 'sellerForm', type: 'file', label: 'Seller Form', value: sellerForm},
            { key: 'commissionBreakdown', type: 'file', label: 'Commission Breakdown', value: commissionBreakdown},
            { key: 'waterRates', type: 'file', label: 'Water Rates', value: waterRates},
        ]

        return (
            !!client ? 
            <SaleStage
                title="Reservation"
                fields={step1Fields}
                isCompleted={isCompleted}
                completionDate={completionDate}
                client={client}
                stage="reservation"
                updateClient={updateClient}
                others={others}
                previousStep={null}
                nextStep={this.props.nextStep}
            /> : null
        )
    }
}

export default StepSS1
